import { supervisorsService } from "@/apis/services"
import { IPaginationMeta, ISupervisorParam, ISupervisor } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface ISupervisorState {
  supervisors: ISupervisor[]
  currentSupervisor: ISupervisor | null
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchSupervisors: (params: ISupervisorParam) => Promise<void>
}

const initialState = {
  supervisors: [],
  currentSupervisor: null,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useSupervisorsStore = create<ISupervisorState>()(
  devtools(set => ({
    ...initialState,
    fetchSupervisors: async (params: ISupervisorParam) => {
      set({ isLoading: true, error: null })
      try {
        const response = await supervisorsService.getSupervisors(params)
        set({ supervisors: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
